var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOptionsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "currentcolor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.25 0.75C2.25 0.3375 1.9125 0 1.5 0C1.0875 0 0.75 0.3375 0.75 0.75V3H2.25V0.75ZM2.25 3.75H0.75C0.3375 3.75 0 4.0875 0 4.5V6C0 6.4125 0.3375 6.75 0.75 6.75H2.25C2.6625 6.75 3 6.4125 3 6V4.5C3 4.0875 2.6625 3.75 2.25 3.75ZM11.25 0.75C11.25 0.3375 10.9125 0 10.5 0C10.0875 0 9.75 0.3375 9.75 0.75V2.25H11.25V0.75ZM6.75 0.75C6.75 0.3375 6.4125 0 6 0C5.5875 0 5.25 0.3375 5.25 0.75V5.25H6.75V0.75ZM0.75 11.25C0.75 11.6625 1.0875 12 1.5 12C1.9125 12 2.25 11.6625 2.25 11.25V7.5H0.75V11.25ZM11.25 3H9.75C9.3375 3 9 3.3375 9 3.75V5.25C9 5.6625 9.3375 6 9.75 6H11.25C11.6625 6 12 5.6625 12 5.25V3.75C12 3.3375 11.6625 3 11.25 3ZM9.75 11.25C9.75 11.6625 10.0875 12 10.5 12C10.9125 12 11.25 11.6625 11.25 11.25V6.75H9.75V11.25ZM6.75 6H5.25C4.8375 6 4.5 6.3375 4.5 6.75V8.25C4.5 8.6625 4.8375 9 5.25 9H6.75C7.1625 9 7.5 8.6625 7.5 8.25V6.75C7.5 6.3375 7.1625 6 6.75 6ZM5.25 11.25C5.25 11.6625 5.5875 12 6 12C6.4125 12 6.75 11.6625 6.75 11.25V9.75H5.25V11.25Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOptionsIcon);
export default __webpack_public_path__ + "static/media/OptionsIcon.24531369.svg";
export { ForwardRef as ReactComponent };